<template>
	<div class="page portfolio">
		<TopSubMenu :menu = "$store.state.gnb.menuList[1].subCategory"></TopSubMenu>

		<!-- portfolio -->
		<section class="secWrap portfolioWrap">
			<div class="portfolioList">
				<PortfolioItem class="portfolioCompWrap" :list="portfolio.list"></PortfolioItem>
			</div>
		</section>
		<button class="btnMore" v-if="btnMore" @click="moreListDisplay">더보기<b-icon icon="plus" size="is-small" type="is-white"></b-icon></button>
		<Footer/>
	</div>
</template>
<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import PortfolioItem from '../components/PortfolioItem'
import TopSubMenu from '../components/TopSubMenu'
import Footer from '../components/Footer'

export default {
	name: 'Portfolio',
	components: {
		PortfolioItem,
		TopSubMenu,
		Footer
	},
	data () {
		return {
			receivedData: {},
			pageNum: 1,
			btnMore: true,
			portfolio: {
				list: [/*
					{
						listTop: true,
						clientLogo: require('@/assets/images/partner-thumb-samsunglife@2x.png'),
						workTitle: '新 태블릿 고도화',
						clientName: '삼성생명',
						year: '2019-2020',
						keyword: 'mobile',
						mainImg: require('@/assets/images/portfolio-cover-samsunglife-2020newtablet@2x.jpg'),
						detail: '시간과 장소에 상관없이<br>주요 경영지표를 확인할 수 있는<br>모바일 영업지원 고도화 시스템 구축<br><br>목표대비 미달성 지표에 대한<br>상시적 모니터링 시스템<br>고도화 구축',
						detailImg: [
							{
								thumb: require('@/assets/images/temp-portfolio-cj-enm-1000.png'),
								img: require('@/assets/images/temp-portfolio-cj-enm-1000.png'),
								link: ''
							},
							{
								thumb: require('@/assets/images/temp-main-portfolio-item1@2x.png'),
								img: require('@/assets/images/temp-main-portfolio-item1@2x.png'),
								link: ''
							}
						],
						link: '/portfolio'
					}
				 */]
			}
		}
	},
	mounted () {
		// data load
		this.$axios.post(this.$store.state.dataUrl + '/twosonPortfolioList')
			.then(response => {
				// console.log('portfolioList : ', response.data)
				// this.receivedData = response.data
				this.portfolio.list = response.data
			})
			.catch(error => {
				console.log('* error : ' + error.response)
			})
	},
	created () {
		AOS.init()
	},
	destroyed () {},
	methods: {
		moreListDisplay () {
			console.log('> moreListDisplay')
			this.pageNum++
			this.$axios.post(this.$store.state.dataUrl + '/twosonPortfolioList?page=' + this.pageNum)
				.then(response => {
					if (response.data.length > 0) {
						if (response.data.length < 18) {
							this.btnMore = false
						}
						this.portfolio.list = this.portfolio.list.concat(response.data)
					} else {
						this.btnMore = false
					}
				})
				.catch(error => {
					console.log('* error : ' + error.response)
				})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/css/variables.scss';
.portfolio {
	position: relative;
	padding-top: 88px;
	height: auto;
	width: 100%;
	background-color: $c-gray-light;
	.portfolioWrap {
		max-width: $mxW;
		margin: 0 auto;
		padding: 80px 0;
		.portfolioList {
			text-align: center;
			.portfolioCompWrap {
				display: inline-block;
				&:after {
					display: block;
					clear: both;
					content: '';
				}
			}
		}
	}
}
.btnMore {
	display: block;
	width: 100%;
	height: 90px;
	text-align: center;
	font-size: $text-medium; color: $c-white;
	background-color: $c-gray-m;
	cursor: pointer;
	.icon {margin-left: 8px;}
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
	.portfolio {
		.portfolioWrap {
			padding: 24px 0 80px 0;
		}
	}
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	//css
	.portfolio {
		.portfolioWrap {
			padding: 24px 0 100px 0;
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//css
	.portfolio {
		.portfolioWrap {
			padding: 14px 0 100px 0;
			.portfolioList {
				padding: 0 12px;
			}
		}
	}
}
</style>
